import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Environment, Response, UserExist } from '@viso/core/models';
import { ENVIRONMENT } from '../environment/environment.service';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  constructor(
    @Inject(ENVIRONMENT) private environment: Environment,
    private http: HttpClient
  ) {}

  userExist(email_id: string, userType: string) {
    return this.http.post<Response<UserExist>>(`${this.environment.API_URL}/email-exists`, {
      email_id,
      user_type: userType,
    });
  }
}
